import { Helmet } from 'react-helmet-async';
import { useState } from "react";
import "./Groups.css";
import { FaChevronDown } from "react-icons/fa";
import {groups} from "../../data/groupsData.js"
import ImageWithSource from "../../components/ImageWithSource/ImageWithSource.js";

export default function Groups() {
    const [expandedGroupId, setExpandedGroupId] = useState(null);

    const toggleGroup = (id) => {
        setExpandedGroupId((prevId) => (prevId === id ? null : id));
    };

    const getGroupsList = () => {
        const groupNames = groups.map(group => group.name).join(', ');
        return groupNames;
    };

    const getMetaDescription = () => {
        const groupCount = groups.length;
        const groupNames = getGroupsList();
        return `Parafia św. Urszuli Ledóchowskiej w Częstochowie zaprasza do wspólnot parafialnych. ${groupCount} grup: ${groupNames}. Dołącz do wspólnoty: Liturgiczna Służba Ołtarza, Schola, Żywy Różaniec, Apostolat Margaretka i inne.`;
    };

    return (
        <>
            <Helmet>
                <title>Grupy parafialne – Parafia św. Urszuli Ledóchowskiej w Częstochowie</title>
                <meta name="description" content={getMetaDescription()} />
                <meta name="keywords" content="grupy parafialne, wspólnoty parafialne, Liturgiczna Służba Ołtarza, schola, Żywy Różaniec, Apostolat Margaretka, wspólnota intronizacji, spotkania młodzieży, katecheza, św. Urszula Ledóchowska, Częstochowa" />
                <meta property="og:title" content="Grupy parafialne – Parafia św. Urszuli Ledóchowskiej" />
                <meta property="og:description" content={`Dołącz do wspólnoty w parafii św. Urszuli Ledóchowskiej. ${groups.length} grup parafialnych: ${getGroupsList()}. Sprawdź terminy spotkań i kontakt z opiekunami.`} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://swurszula.pl/grupy-parafialne" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Grupy parafialne – Parafia św. Urszuli Ledóchowskiej" />
                <meta name="twitter:description" content={`Wspólnoty parafialne w parafii św. Urszuli Ledóchowskiej. Sprawdź ofertę grup i dołącz do nas!`} />
            </Helmet>

            <div className="group-section-wrapper">
                {groups.map((group) => (
                    <div key={group.id} className="group-tile">
                        <div className="group-header" onClick={() => toggleGroup(group.id)}>
                            <div className="group-left">
                                <ImageWithSource src={group.image} overlayText={group.source} link={group.link}/>
                                <h3 className="group-title">{group.name}</h3>
                            </div>
                            <p className="group-arrow">
                                {expandedGroupId === group.id ? (
                                    <FaChevronDown style={{ transform: "rotate(180deg)", transition: "0.3s" }} />
                                ) : (
                                    <FaChevronDown />
                                )}
                            </p>
                        </div>

                        {expandedGroupId === group.id && (
                            <div className="group-details">
                                <div className="group-info-row">
                                    <span className="label">{group.leaderName}:</span>
                                    <span className="value">{group.leader}</span>
                                </div>

                                <div className="group-info-row">
                                    <span className="label">Spotkania:</span>
                                    <span className="value">{group.meeting}</span>
                                </div>

                                <hr className="divider" />

                                <p className="group-description">{group.description}</p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </>
    );
}